import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import AllGamesLiveBets from './allGamesLiveBets';
import LiveBetsHeader from './liveBetsHeader';
import { liveUpdateStore } from '../../store/liveUpdateStore';
import {
  ALL_GAMES_COLUMN_ID,
  HIGH_ROLLERS_COLUMN_ID,
  HISTORY_COLUMN_ID,
  LIVE_BETS_COLUMN_HEADER,
  THIS_GAMES_COLUMN_ID,
} from '../../core/constants/liveBetsContants';
import LiveBetsByGame from './liveBetsByGame';
import HighRollers from './highRollers';
import BetHistory from './betHistory';
import useTranslation from '../../hooks/useTranslation';
import './InfoTables.scss';

const LiveBets = observer(() => {
  const { selectedColumn, setSelectedColumn } = liveUpdateStore;
  const t = useTranslation();

  const selectedTableInfo = useMemo(() => {
    // if (!isOverwriteMainCss) {
    //   return {
    //     [THIS_GAMES_COLUMN_ID]: <LiveBetsByGame />,
    //     [HISTORY_COLUMN_ID]: <BetHistory />,
    //     [HIGH_ROLLERS_COLUMN_ID]: <HighRollers />,
    //   };
    // }
    return {
      [ALL_GAMES_COLUMN_ID]: <AllGamesLiveBets />,
      [THIS_GAMES_COLUMN_ID]: <LiveBetsByGame />,
      [HISTORY_COLUMN_ID]: <BetHistory />,
      [HIGH_ROLLERS_COLUMN_ID]: <HighRollers />,
    };
  }, []);

  const liveBetsColumnHeader = useMemo(() => {
    // if (!isOverwriteMainCss) {
    //   const columns = LIVE_BETS_COLUMN_HEADER.slice(1);
    //   columns.splice(0, 1, {
    //     title: TranslationKeys.LiveBets,
    //     id: THIS_GAMES_COLUMN_ID,
    //   });
    //   return columns;
    // }
    return LIVE_BETS_COLUMN_HEADER;
  }, []);
  return (
    <div className='cpt-info-holder'>
      <LiveBetsHeader
        t={t}
        selectedColumn={selectedColumn}
        setSelectedColumn={setSelectedColumn}
        liveBetsColumnHeader={liveBetsColumnHeader}
      />
      {selectedTableInfo[selectedColumn]}
    </div>
  );
});
export default LiveBets;
